<template>
  <div class="event-list-page">
    <a-card :bordered="false" class="content">
      <div class="page-header">
        <h1 class="page-title">
          <span class="title-text">活动报名</span>
          <span class="title-bg">EVENT SIGNUP</span>
        </h1>
      </div>

      <div class="search-section">
        <a-input
          v-model="queryParam.keyword"
          placeholder="搜索活动"
          class="search-input"
          @keyup.enter.native="searchQuery"
        >
          <a-icon slot="prefix" type="search" />
        </a-input>
        <a-button type="primary" icon="search" @click="searchQuery">查询</a-button>
      </div>

      <a-spin :spinning="loading">
        <a-row :gutter="[20, 20]">
          <a-col v-for="item in dataSource" :key="item.id" :xs="24" :sm="12" :lg="8">
            <div class="event-card" @click="goDetail(item)">
              <div class="cover">
                <img v-if="item.cover" :src="getFileAccessHttpUrl(item.cover)" :alt="item.eventName" />
                <div v-else class="cover-empty">暂无封面</div>
              </div>
              <div class="event-body">
                <h3>{{ item.eventName }}</h3>
                <div class="event-time">{{ item.startTime }} 至 {{ item.endTime }}</div>
                <div class="event-meta">
                  <span>剩余名额：{{ item.remainingNum === null || item.remainingNum === undefined ? '不限' : item.remainingNum }}</span>
                </div>
              </div>
            </div>
          </a-col>
        </a-row>
        <a-empty v-if="!loading && dataSource.length === 0" description="暂无进行中的活动" />
      </a-spin>

      <div class="pagination-wrapper">
        <a-pagination
          :current="ipagination.current"
          :total="ipagination.total"
          :pageSize="ipagination.pageSize"
          showSizeChanger
          @change="handlePageChange"
          @showSizeChange="handlePageSizeChange"
        />
      </div>
    </a-card>
  </div>
</template>

<script>
import { getAction, getFileAccessHttpUrl } from '@/api/manage'

export default {
  name: 'EventList',
  data() {
    return {
      loading: false,
      dataSource: [],
      queryParam: {},
      ipagination: {
        current: 1,
        pageSize: 12,
        total: 0
      }
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    getFileAccessHttpUrl,
    loadData() {
      this.loading = true
      getAction('/xjtech/event/public/list', {
        pageNo: this.ipagination.current,
        pageSize: this.ipagination.pageSize,
        keyword: this.queryParam.keyword
      }).then(res => {
        if (res.success) {
          this.dataSource = (res.result && res.result.records) || []
          this.ipagination.total = (res.result && res.result.total) || 0
        } else {
          this.$message.warning(res.message || '获取活动失败')
        }
      }).finally(() => {
        this.loading = false
      })
    },
    searchQuery() {
      this.ipagination.current = 1
      this.loadData()
    },
    handlePageChange(page, pageSize) {
      this.ipagination.current = page
      this.ipagination.pageSize = pageSize
      this.loadData()
    },
    handlePageSizeChange(current, size) {
      this.ipagination.current = 1
      this.ipagination.pageSize = size
      this.loadData()
    },
    goDetail(item) {
      this.$router.push({ path: '/event/detail', query: { id: item.id } })
    }
  }
}
</script>

<style scoped lang="less">
.event-list-page {
  max-width: 1200px;
  margin: 0 auto;
}
.content {
  min-height: 500px;
}
.page-header {
  margin-bottom: 24px;
}
.page-title {
  position: relative;
  margin: 0;
  .title-text {
    font-size: 28px;
    font-weight: 600;
    color: #1f1f1f;
  }
  .title-bg {
    margin-left: 12px;
    color: #e8e8e8;
    font-size: 20px;
  }
}
.search-section {
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
}
.search-input {
  max-width: 360px;
}
.event-card {
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
  background: #fff;
  transition: box-shadow .2s, transform .2s;
  &:hover {
    box-shadow: 0 8px 24px rgba(0, 0, 0, .08);
    transform: translateY(-2px);
  }
}
.cover {
  height: 180px;
  background: #f5f5f5;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.cover-empty {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
}
.event-body {
  padding: 16px;
  h3 {
    margin: 0 0 10px;
    font-size: 18px;
    color: #1f1f1f;
  }
}
.event-time,
.event-meta {
  color: #666;
  line-height: 1.8;
}
.pagination-wrapper {
  margin-top: 24px;
  text-align: right;
}
</style>
